<template>
 <ion-page id="big-button-preferences-page" >
    <ion-content >
    </ion-content>
  </ion-page>
</template>

<script setup>

  import { IonCheckbox,IonLabel, IonSelect, IonSelectOption,IonRadioGroup,IonRadio, IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent,modalController } from '@ionic/vue';


  import { getCurrentInstance, ref , watch, onMounted } from 'vue';
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
  import { t, setTranslationLanguage } from '@/composables/translateText.js'

  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { forceColorsById } from '@/composables/forceColors.js'
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { availableWidthHeight }  from '@/composables/screenSize'
  import ModalActionReplacement from '@/components/ModalActionReplacement.vue';
  import ModalGenericSingleList from '@/components/ModalGenericSingleList.vue'

  const emit = defineEmits(['menu-item-click','menu-help-item-click'])

  const PREFERENCE_SHOW_BIG_BUTTONS = 0
  const PREFERENCE_HEIGHT = 1
  const PREFERENCE_EYEGAZE = 2
 
  const connectionStore = useConnectionStore()
  const isDark = ref(connectionStore.getDarkmode != "light")

  // this is confusing but NOW there is no check for if the system is in dark/light mode
  // there is only light, chessvis (dark colors) and lichess (dark colors)
  const darkBoardColors = ref(connectionStore.getDarkBoardColors)
  if (darkBoardColors.value == "dark")
    darkBoardColors.value = "light"
  //console.log("DARK BOARD COLOR HERE",darkBoardColors.value)

  // for big button preferences, use big buttons in display

  const whichMenu = localStorage.getItem("whichMenu")
  var showBigButtonsSelected = connectionStore.getShowBigButtons ? "yes" : "no"
  const showBigButtonString = t("Show Big Buttons - Everywhere")
  const showBig = [
      { name :  t("Yes"), radio : "yes"},
      { name :  t("No"), radio : "no"},
    ]

  var eyeGazeSelected = connectionStore.getIsEyeGaze ? "yes" : "no"
  const eyeGazeString = t("EyeGaze Tracking for Board Play")
  const eyeGaze = [
      { name :  t("Yes"), radio : "yes"},
      { name :  t("No"), radio : "no"},
    ]

  var heightSelected = connectionStore.getToolbarScalePercentage
  const buttonHeightString = t("Button Height Scaling Factor")
  const buttonHeights = [
      { name :  "1x", radio : "100"},
      { name :  "1.25x", radio : "125"},
      { name :  "1.5x", radio : "150"},
      { name :  "1.75x", radio : "175"},
      { name :  "2x", radio : "200"},
      { name :  "2.5x", radio : "250"},
      { name :  "3x", radio : "300"},
      { name :  "4x", radio : "400"},
    ]

  var preferenceArray = []


  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })


  onMounted(() => {
    doStartupCheck(false,afterStartupCallbackRoutine)
  })

  // start big button 

  const openGenericSingleListModal = async (onePreference) => {
    const modal = await modalController.create({
      component: ModalGenericSingleList,
      componentProps: {
        displayArray : onePreference.array,
        initialValue : onePreference.value,
        title : onePreference.text,
        forceBigButtons : true
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    //console.log("Back from modal",data,role)

    if (role === 'confirm') {
      // did user leave the select the same?
      if (data.selected == onePreference.value) {
        delayBeforeShowingPreferences()
        return
      }

      //console.log("CONFIRM in static",data)
      handleChange(null,onePreference.code,data.selected)

      //setOptions(data.selected)
   }
    delayBeforeShowingPreferences()

  };

  function preferenceClick(index) {
    const onePreference = preferenceArray[index]
    openGenericSingleListModal(onePreference)
    
  }

  // delay lets windows close so we can then open the actual value selection

  function delayBeforeShowingPreferences() {

    let timerSleepAmount = 250

    function oneInterval() {
      clearInterval(id)
      openPreferenceModal()
    }
    var id = setInterval(oneInterval, timerSleepAmount)
  }

  function delayBeforeShowingOption(optionId) {

    let timerSleepAmount = 250

    function oneInterval() {
      clearInterval(id)
      preferenceClick(optionId)
    }
    var id = setInterval(oneInterval, timerSleepAmount)
  }

  function currentDisplayName(array,current) {
    for (var i=0; i < array.length; i++)
      if (array[i].radio == current)
        return (array[i].name)
    return ("")
  }

  const openPreferenceModal = async () => {

    preferenceArray = []

    preferenceArray.push({text : showBigButtonString, code : "showbigbuttons",
                value: showBigButtonsSelected, array: showBig,
                current : currentDisplayName(showBig,showBigButtonsSelected),
                data : { index : PREFERENCE_SHOW_BIG_BUTTONS}})
    preferenceArray.push({text : buttonHeightString, code : "buttonheight",
                value: heightSelected, array: buttonHeights,
                current : currentDisplayName(buttonHeights,heightSelected),
                data : { index : PREFERENCE_HEIGHT}})
    preferenceArray.push({text : eyeGazeString, code : "eyegaze" ,
                value: eyeGazeSelected, array: eyeGaze,
                current : currentDisplayName(eyeGaze,eyeGazeSelected),
                data : { index : PREFERENCE_EYEGAZE}})   
     
    
    const modal = await modalController.create({
      component: ModalActionReplacement,
      componentProps: {
        displayArray : preferenceArray,
        title : t('Big Button & EyeGaze Preferences'),
        forceBigButtons : true
       }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    //console.log("ROLE ",role,data)
    if (role === 'selected') {
      //console.log("CONFIRM in static",data)
      delayBeforeShowingOption(data)
   }
   else {
      //console.log("emit to big_button_menu")
      emit("menu-item-click","big_button_menu",t("Big Button Menu"),"buttons")
   }
  };

  // end big buttion approach


  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    openPreferenceModal()

  }

  function handleChange(ev,which,bigButtonValue) {

    const valueSelected = (ev == null) ? bigButtonValue : ev.detail.value
    //console.log('ionChange fired with value: ' + valueSelected,which);

    switch (which) {
      case "showbigbuttons" :
        connectionStore.setShowBigButtons(valueSelected == "yes")
        showBigButtonsSelected = valueSelected
        break
      case "eyegaze" :
        connectionStore.setIsEyeGaze( (valueSelected == "yes"))
        eyeGazeSelected = valueSelected
        break
      case "buttonheight" :
        connectionStore.setToolbarScalePercentage(valueSelected)
        heightSelected = valueSelected
        break
    }
   
  }

  function handleCancel() {
    //console.log('ionCancel fired');
  }
  function handleDismiss() {
    //console.log('ionDismiss fired');
  }

  function processUpdateJsonResponse (json) {
    //console.log("update single value return ",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
  }
  
</script>

 ion-select {
        width: 100%; /* or a specific pixel value like 200px */
        max-width: 100%; /* or a specific pixel value */
    }


     ion-select::part(container) {
        width: 100%;
    }

ion-select label-text-wrapper {
  max-width: none; /* Remove default max-width */
  width: 400px; /* Or your desired width */
}

ion-select label-text-wrapper label-text {
  text-overflow: unset; /* Prevent text truncation */
  overflow: visible; /* Allow text to overflow if needed */
}

ion-select::part(text) {
  width: 100%;
}
<style scoped>

</style>
